import React, { FC } from "react";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Radio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Header, Body, Typography } from "../styled";
// import { Typography } from "@mui/material";
import { format, formatISO } from "date-fns";
import Stack from "@mui/material/Stack";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";





const HealthInsurance: FC = () => {
    return (
        <Box mt={1}>
        <Header>
            <Box display='flex'>
                <TextField
                    label="Номер договора"
                    variant="outlined"
                    size="small"
                    sx={{ mb: 2, width: "300px" }}
                />
            </Box>
            <Box display='flex'>
                <TextField
                    label="Серия полиса"
                    variant="outlined"
                    size="small"
                    sx={{ mb: 2, width: "300px" }}
                />
            </Box>
            <Box display='flex'>
                <TextField
                    label="Номер полиса"
                    variant="outlined"
                    size="small"
                    sx={{ mb: 2, width: "300px" }}
                />
            </Box>
            <Box display='flex'>
                <TextField
                    label="Дата выдачи полиса"
                    value={format(1683886255004, "dd.MM.yyyy")}
                    variant="outlined"
                    size="small"
                    sx={{ width: "300px", mb: 2 }}
                />
            </Box>
            <Box display='flex'>
                <TextField
                    label="Дата договора"
                    value={format(1683886255004, "dd.MM.yyyy")}
                    variant="outlined"
                    size="small"
                    sx={{ width: "300px", mb: 2 }}
                />
            </Box>
            <Box display='flex'>
                <TextField
                    label="Страховая компания"
                    variant="outlined"
                    size="small"
                    sx={{ width: "800px" }}
                />
            </Box>
        </Header>
        <Body>

        </Body>
        </Box>
    );
};

export default HealthInsurance;
